import {AddToDriveRounded} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const drivers = {
    id: 'drivers',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'drivers',
            title: 'Drivers',
            type: 'item',
            url: '/drivers',
            icon: AddToDriveRounded,
            breadcrumbs: false,
            
        },
       
    ]
};

export default drivers;
